import React, { useState, useEffect } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../pages/app/protected/firebase'; // adjust if needed
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const container = document.getElementById('circle-container');
    if (!container) return;

    container.innerHTML = '';

    const circles = [
      {
        width: 450,
        height: 450,
        left: 1100,
        top: 40,
        background: 'linear-gradient(200.63deg, #FFE600 25.75%, #8946EA 77.76%)',
      },
      {
        width: 250,
        height: 250,
        left: 600,
        top: 50,
        background: 'linear-gradient(208.25deg, #FFE600 16.24%, #8946EA 36.77%)',
        transform: 'matrix(-1, 0, 0, 1, 0, 0)'
      },
      {
        width: 430,
        height: 430,
        left: 50,
        top: 350,
        background: 'linear-gradient(219.99deg, #FFE600 32.87%, #8146E2 68.9%)',
      },
      {
        width: 180,
        height: 180,
        left: 850,
        top: 600,
        background: 'linear-gradient(191.73deg, #FFE600 12.04%, #8946EA 75.7%)',
      }
    ];

    circles.forEach(({ width, height, left, top, background, transform }) => {
      const circle = document.createElement('div');
      Object.assign(circle.style, {
        position: 'absolute',
        width: `${width}px`,
        height: `${height}px`,
        left: `${left}px`,
        top: `${top}px`,
        background,
        borderRadius: '50%',
        opacity: '1',
        filter: 'blur(0px)',
        zIndex: 0,
        pointerEvents: 'none',
        transform: transform || ''
      });
      container.appendChild(circle);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccessMessage('Password reset email sent! Check your inbox.');
    } catch (error) {
      console.error(error);
      if (error.code === 'auth/user-not-found') {
        setErrorMessage('Email not found. Please check again.');
      } else if (error.code === 'auth/invalid-email') {
        setErrorMessage('Invalid email address.');
      } else {
        setErrorMessage('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#05060f] relative overflow-hidden px-6">
      <div id="circle-container" className="absolute inset-0 overflow-hidden z-0" />

      <div className="w-full max-w-4xl relative z-10 flex flex-col md:flex-row overflow-hidden rounded-2xl shadow-lg backdrop-blur-xl border border-white/20 bg-gradient-to-br from-[#1a1a1a]/60 to-[#2c2c2c]/30">
        
        {/* Left Side */}
        <div className="md:w-1/3 p-8 flex flex-col items-start justify-center bg-gradient-to-br from-white/80 to-white/20 rounded-l-2xl">
          <h2 className="text-4xl font-extrabold text-black leading-tight" style={{ fontFamily: 'Century Gothic' }}>
            RESET<br />
            <span className="text-black">PASSWORD</span>
          </h2>
          <div className="w-16 h-1 bg-black mt-4"></div>
        </div>

        {/* Right Side */}
        <div className="md:w-2/3 p-8 lg:p-12 flex flex-col justify-center">
          <h3 className="text-2xl font-semibold text-white mb-6 text-center md:text-left">
            Forgot Your Password?
          </h3>

          {successMessage && (
            <div className="bg-green-100 text-green-700 p-3 rounded mb-4 text-center">
              {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="bg-red-100 text-red-700 p-3 rounded mb-4 text-center">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-gray-300 mb-1">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-full bg-gray-700/50 text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="Enter your email"
              />
            </div>

            <button
                type="submit"
                disabled={loading}
                className="w-[100%] py-3 px-4 rounded-full text-white bg-[#392954] hover:bg-[#392954]/80 backdrop-blur-md hover:scale-105 transition-all duration-300 font-['Century_Gothic']"
                style={{
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  letterSpacing: '0.3em',
                  paddingTop: 'clamp(10px, 2vw, 14px)',
                  paddingBottom: 'clamp(10px, 2vw, 14px)',
                }}
              >
                {loading ? (
                  <div className="flex items-center">
                    <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Sending...
                  </div>
                ) : (
                  "SEND LINK"
                )}
              </button>
          </form>

          <div className="text-center mt-6" style={{ fontFamily: 'Century Gothic', letterSpacing: '0.1em' }}>
            <Link to="/login" className="text-purple-400 hover:underline">
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
